import { SearchField } from "../../../search/entities/search-field";
import { LossSubmission } from "./lossSubmission";

export class FormLookUp {
    lossSubmission: LossSubmission;
}

 






// WEBPACK FOOTER //
// ./src/app/modules/validate-loss-data-submission/shared/entities/formLookUp.ts